module.exports = __webpack_public_path__ + "static/media/VideoPlay.130c9af1.png";